import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import CONSTANTS from '../../constants';
import OptionHelper from '../../helpers/OptionHelper';
import ViewHelper from '../../helpers/ViewHelper';
import AnalyticsService from '../../services/AnalyticsService';
import CartService from '../../services/CartService';
import withBackButtonHandled from '../shared/WithBackButtonHandled';
import ItemModalDetail from './ItemModalDetail';

class ItemModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      portionSize: null,
      errors: [],
      quantity: 1,
      comment: ''
    };
  }

  componentDidMount() {
    const item = this.props.item || {};
    const location = this.props.location;

    // Extract Portion Size
    const portionSize = item?.Portion?.PortionSizes?.[0]
    this.setState({ portionSize });

    // Scroll to modal-start element after a short delay
    setTimeout(() => {
      const element = document.getElementById('modal-start');
      if (element) {
        element.scrollIntoView();
      }
    }, 50);

    // Prepare newItem object for Firebase Event
    const newItem = [
      {
        item_name: item.menu_name || 'Unknown Item',
        item_id: item.menu_id || 'Unknown ID',
        price: item.menu_price || '0',
        item_brand: location.name,
        item_category: location.category_name,
        quantity: '1',
      },
    ];

    // Trigger Firebase Event
    if (typeof this.firebaseEvent === 'function') {
      this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.VIEW_ITEM, newItem);
    } else {
      console.error('Firebase event function is not defined');
    }

    // Helper function to generate Alt Title
    const generateAltKeywords = (item, location) => {
      let altKeywords = item.item_keywords || location.meta.item_keywords || location.meta.appSettings?.item_meta_keywords || `${item.menu_name} by ${location.name}`;
      altKeywords = altKeywords.replace(/\[productname\]/g, item.menu_name);
      altKeywords = altKeywords.replace(/\[item\]/g, item.menu_name);
      altKeywords = altKeywords.replace(/\[location\]/g, location.name);
      return altKeywords;
    };

    // Helper function to generate Alt Title
    const generateAltTitle = (item, location) => {
      let altTitle = item.alt_title || location.meta.item_title || location.meta.appSettings?.item_meta_title || `${item.menu_name} by ${location.name}`;
      altTitle = altTitle.replace(/\[productname\]/g, item.menu_name);
      altTitle = altTitle.replace(/\[item\]/g, item.menu_name);
      altTitle = altTitle.replace(/\[location\]/g, location.name);
      return altTitle;
    };

    // Helper function to generate Alt Description
    const generateAltDescription = (item, location) => {
      let altDescription = item.alt_description || location.meta.item_description || location.meta.appSettings?.meta_item_description || '';

      if (altDescription) {
        altDescription = altDescription.replace(/\[productname\]/g, item.menu_name);
        altDescription = altDescription.replace(/\[item\]/g, item.menu_name);
        altDescription = altDescription.replace(/\[location\]/g, location.name);
        altDescription = altDescription.replace(/\[address\]/g, location.formattedAddress);
        altDescription = altDescription.replace(/\[city\]/g, location.city);
        altDescription = altDescription.replace(/\[cuisinetype\]/g, location.category_name);

      }

      if (!altDescription) {
        altDescription = `Order directly from ${location.name} for delivery, takeaway, curbside pickup or dining in at their restaurant. Support restaurants by ordering directly! | Powered by Plugd`;
      } else {
        altDescription += ' | Powered by Plugd';
      }

      return altDescription;
    };

    // Generate Alt Title and Description
    const alt_title = generateAltTitle(item, location);
    const alt_description = generateAltDescription(item, location);
    const alt_keywords = generateAltKeywords(item, location);

    // Set document title and description
    ViewHelper.setDocumentTitle(alt_title);
    ViewHelper.setDocumentDescription(alt_description);
    ViewHelper.setMetaKeywords(alt_keywords);
    // Set Canonical URL
    const menuName = item.menu_name?.replace(/ /g, '-') || 'default-item';
    ViewHelper.setCanonical(`/${location.slug}/item/${menuName}-${item.menu_id}`);
  }



  getOptions() {
    return this.props.item.MenuOptions;
  }

  showItemDetails(item) {
    this.props.history.push(
      `${CONSTANTS.BASE_URL}${this.props.location.slug}/menu/${item.menu_id}`
    );
  }

  getBorderClass(itemId, reviewAble, selectedItems, quantity) {
    if (reviewAble) {
      if (selectedItems.find((item) => parseInt(item.menu_id, 10) === parseInt(itemId, 10)))
        return 'item-with-quantity';
    } else if (quantity > 0) return 'item-with-quantity';

    return '';
  }

  isChecked(item) {
    return (
      this.props.selectedItems &&
      !!this.props.selectedItems.find((i) => parseInt(item.menu_id, 10) === parseInt(i.menu_id, 10))
    );
  }

  onCheckboxChange(item) {
    if (this.isChecked(item)) return this.props.onRemoveItem(item);
    this.props.onSelectItem(item);
  }

  onPortionSizeSelect(selectedPortionSize) {
    this.setState({ portionSize: selectedPortionSize });
  }

  onRadioSelect(selectedOption, selectedOptionValue) {
    let options = this.state.options;
    // Update option value
    _.remove(options, (option) => option.option_id === selectedOption.option_id);
    options.push(OptionHelper.optionObject(selectedOption, selectedOptionValue));

    // Clear validation errors for this option
    let errors = OptionHelper.clearError(this.state.errors, selectedOption);
    this.setState({ options, errors });
  }

  onSelectAdd(selectedOption, selectedOptionValue) {
    let options = this.state.options;
    if (OptionHelper.canAddOption(options, selectedOption)) {
      options.push(OptionHelper.optionObject(selectedOption, selectedOptionValue));
      // Clear validation errors for this option
      let errors = OptionHelper.clearError(this.state.errors, selectedOption);
      this.setState({ options, errors });
    } else {
      this.setState({
        errors: [
          {
            option_id: selectedOption.option_id,
            message: `You can only select ${selectedOption.max} ${selectedOption.option_name}`
          }
        ]
      });
    }
  }

  onSelectRemove(selectedOption, selectedOptionValue) {
    let options = this.state.options;
    // Remove last occurrence of this option value
    const alreadySelected = _.findLastIndex(
      options,
      (option) => option.option_value_id === selectedOptionValue.option_value_id
    );
    if (alreadySelected > -1) _.pullAt(options, [alreadySelected]);

    // Clear validation errors for this option
    let errors = OptionHelper.clearError(this.state.errors, selectedOption);
    this.setState({ options, errors });
  }

  onCommentChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  addOptionsAndGoBack() {
    if (!this.props.isOrderingEnabled) {
      return;
    }
    if (this.props.location.is_master_venue) {
      this.props.closeModal();
      localStorage.setItem('selectedItem', JSON.stringify(this.props.item));
      this.props.toggleRouteModal();
      return;
    }
    let orderTypesData = CartService.getOrderData(
      this.props.location.orderTypes,
      this.props.location
    );
    if (!orderTypesData) {
      this.props.togglePrefModal();
    } else {
      let validationErrors = OptionHelper.validationErrors(this.state.options, this.getOptions());
      if (validationErrors && validationErrors.length > 0) {
        this.setState({ errors: validationErrors });
        return this.scrollToFirstError(validationErrors[0]);
      }
      let quantity = CartService.getQuantityFor(this.props.item, this.props.location.loc_id);
      if (this.props.location.is_homecheff && this.props.item.daily_limit !== null) {
        if (quantity >= this.props.item.daily_limit) {
          let validationErrors = [];
          validationErrors.push({
            option_id: this.props.item.menu_id,
            message: 'Daily stock quantity has been exceeded.'
          });
          this.setState({ errors: validationErrors });
          return;
        }
      }
      CartService.addItem(
        {
          ...this.props.item,
          loc_id: this.props.location.loc_id,
          options: this.state.options,
          portionSize: this.state.portionSize,
          comment: this.state.comment,
          isRewardItem: this.props.isReward
        },
        this.state.quantity
      );
      let lineItems = CartService.getLineItems(this.props.location.loc_id);
      let items = [];
      for (let i = 0; i < lineItems.length; i++) {
        let newItem = {
          item_name: lineItems[i].menu_name,
          item_id: lineItems[i].menu_id,
          price: lineItems[i].menu_price,
          item_brand: this.props.location.name,
          item_category: this.props.location.category_name,
          index: i + 1,
          quantity: lineItems[i].itemCount
        };
        items.push(newItem);
      }
      this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.ADD_TO_CART, items);
      if (this.props.toast === 1) {
        this.props.getToastSettings(2);
        setTimeout(this.props.getToastSettings.bind(this, 3), 3000);
      }
      this.props.updateCart();
      this.props.toggleModal();
    }
  }

  scrollToFirstError(error) {
    document.getElementById(error.option_id).scrollIntoView();
  }

  firebaseEvent(eventName, items) {
    AnalyticsService.logEvent(eventName, {
      event: eventName,
      ecommerce: {
        items: items
      }
    });
    AnalyticsService.logRestaurantEvent(this.props.location.analytics_id, {
      event: eventName,
      ecommerce: {
        items: items
      }
    });
  }

  increment() {
    if (!this.props.isOrderingEnabled) {
      return;
    }
    if (this.props.location.is_homecheff && this.props.item.daily_limit !== null) {
      let quantity = CartService.getQuantityFor(this.props.item, this.props.location.loc_id);
      if ((quantity + this.state.quantity) < this.props.item.daily_limit) {
        this.setState({ quantity: this.state.quantity + 1 });
      }
    } else {
      this.setState({ quantity: this.state.quantity + 1 });
    }

  }

  decrement() {
    if (this.state.quantity > 1) {
      this.setState({ quantity: this.state.quantity - 1 });
    }
  }

  getMenuStatusForItem(item, selectedOutlet) {
    if (selectedOutlet.stockStatuses) {
      const outlet_status = selectedOutlet && selectedOutlet.stockStatuses[item.menu_id];
      if (outlet_status) {
        return outlet_status.status_id;
      }
    }
    return item.menu_status;
  }

  render() {
    let { location: _location, item } = this.props;
    if (_location && item) {
      if (_location.is_outlet) {
        item.menu_status = this.getMenuStatusForItem(item, _location);
      }
      //let quantity = CartService.getQuantityFor(item, _location.loc_id);
      const closeBtn = (
        <button className="close card-color" onClick={this.props.toggleModal}>
          <FontAwesomeIcon icon={faTimes} color='var(--card-subtitle-color)' />
        </button>
      );
      const originalPrice = OptionHelper.optionsTotal(
        item,
        this.state.options,
        this.state.quantity,
        this.state.portionSize
      );
      const discountedPrice = item.discounts
        ? item.discounts.discountAmountType ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.FIXED
          ? originalPrice - item.discounts.discountAmount
          : originalPrice - (originalPrice * item.discounts.discountAmount) / 100
        : originalPrice;
      const originalPriceLabel = ViewHelper.toCurrency(
        originalPrice,
        _location.currency,
        _location.decimal_places
      );
      const discountedPriceLabel = ViewHelper.toCurrency(
        discountedPrice,
        _location.currency,
        _location.decimal_places
      );
      let menu = item;
      let grid_layout = localStorage.getItem('grid_layout');
      const branding_btn = this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn';
      const card_outline = this.props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : 'card-outline-color-hide';
      if (grid_layout === 'old') {
        return (
          <React.Fragment>
            <Modal
              id={item.menu_id}
              isOpen={this.props.showModal}
              toggle={this.props.toggleModal}
              className={
                item && item.menu_photo
                  ? 'modal item-detail-modal'
                  : 'modal item-detail-modal item-detail-modal-no-img'
              }
            >
              {closeBtn}
              <ModalBody className={`card-color ${card_outline}`}>
                <ItemModalDetail
                  grid_layout={grid_layout}
                  onRselect={this.onRadioSelect.bind(this)}
                  onSelect={this.onSelectAdd.bind(this)}
                  onSelectRemove={this.onSelectRemove.bind(this)}
                  onComment={this.onCommentChange.bind(this)}
                  errors={this.state.errors}
                  _location={_location}
                  locationSettings={this.props.locationSettings}
                  item={item}
                  option={item.Menu_Options}
                  onModalClose={this.props.toggleModal}
                  onIncrement={this.increment.bind(this)}
                  onDecrement={this.decrement.bind(this)}
                  isOrderingEnabled={this.props.isOrderingEnabled}
                  addOptionsAndGoBack={this.addOptionsAndGoBack.bind(this)}
                  quantity={this.state.quantity}
                  portionSize={this.state.portionSize}
                  onPortionSizeSelect={this.onPortionSizeSelect.bind(this)}
                />
              </ModalBody>
              <ModalFooter
                className={
                  menu.menu_status === 2
                    ? 'card-color item-unavailable-modifier-modal d-lg-none d-sm-block d-md-block d-block'
                    : 'card-color d-lg-none d-sm-block d-md-block d-block'
                }
              >
                <div className="container-fluid">
                  <div className="row">
                    {!_location.location_status ||
                      menu.menu_status === 2 ||
                      !this.props.isOrderingEnabled ? (
                      <Button
                        className={`col-lg-12 btn-lg ${branding_btn}`}
                        color="secondary"
                        onClick={this.props.toggleModal}
                      >
                        Cancel
                      </Button>
                    ) : (
                      <div className="add-order">
                        <div className="custom-increment-decrement">
                          <div
                            className={`custom-increment-decrement__decrement card-subtitle-color ${branding_btn}`}
                            onClick={this.decrement.bind(this)}
                          >
                            <span className='branding-btn-font-color'>&#8722;</span>
                          </div>
                          <div className={`custom-increment-decrement__quantity ${branding_btn}`}>
                            <p>{this.state.quantity}</p>
                          </div>
                          <div
                            className={`custom-increment-decrement__increment card-subtitle-color ${branding_btn}`}
                            onClick={this.increment.bind(this)}
                          >
                            <span className='branding-btn-font-color'>&#43;</span>
                          </div>
                        </div>
                        <div
                          className={`item-modal-add-item ${branding_btn}`}
                          onClick={this.addOptionsAndGoBack.bind(this)}
                        >
                          <h2 className="branding-btn-font-color">
                            Add to Cart -&nbsp;
                            {originalPrice === discountedPrice ? (
                              originalPriceLabel
                            ) : (
                              <>
                                <span className="branding-btn-font-color ml-4">
                                  {discountedPriceLabel}
                                </span>
                                &nbsp;
                                <span className="text-decoration-line-through card-subtitle-color ml-1 form-control-sm font-weight-lighter">
                                  {originalPriceLabel}
                                </span>
                              </>
                            )}
                          </h2>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </ModalFooter>
            </Modal>
          </React.Fragment>
        );
      } else if (grid_layout !== 'old') {
        return (
          <React.Fragment>
            <StyledModal
              id={item.menu_id}
              isOpen={this.props.showModal}
              toggle={this.props.toggleModal}
              className={
                item && item.menu_photo
                  ? 'modal item-detail-modal'
                  : 'modal item-detail-modal item-detail-modal-no-img'
              }
            >
              {closeBtn}
              <ModalBody className={`card-color ${card_outline}`}>
                <ItemModalDetail
                  grid_layout={grid_layout}
                  onRselect={this.onRadioSelect.bind(this)}
                  onSelect={this.onSelectAdd.bind(this)}
                  onSelectRemove={this.onSelectRemove.bind(this)}
                  onComment={this.onCommentChange.bind(this)}
                  errors={this.state.errors}
                  _location={_location}
                  locationSettings={this.props.locationSettings}
                  item={item}
                  option={item.Menu_Options}
                  onModalClose={this.props.toggleModal}
                  onIncrement={this.increment.bind(this)}
                  onDecrement={this.decrement.bind(this)}
                  isOrderingEnabled={this.props.isOrderingEnabled}
                  addOptionsAndGoBack={this.addOptionsAndGoBack.bind(this)}
                  quantity={this.state.quantity}
                  portionSize={this.state.portionSize}
                  onPortionSizeSelect={this.onPortionSizeSelect.bind(this)}
                  isReward={this.props.isReward}
                />
              </ModalBody>
              <ModalFooter
                className={
                  menu.menu_status === 2
                    ? 'item-unavailable-modifier-modal main-bg d-lg-none d-sm-block d-md-block d-block card-color'
                    : 'd-lg-none main-bg d-sm-block d-md-block d-block card-color'
                }
              >
                <div className="container-fluid">
                  <div className="row">
                    {!_location.location_status ||
                      menu.menu_status === 2 ||
                      !this.props.isOrderingEnabled ? (
                      <Button
                        className={`col-lg-12 btn-lg ${branding_btn}`}
                        color="secondary"
                        onClick={this.props.toggleModal}
                      >
                        Cancel
                      </Button>
                    ) : (
                      <div className="add-order">
                        <div className="custom-increment-decrement">
                          <div
                            className={`custom-increment-decrement__decrement card-subtitle-color ${branding_btn}`}
                            onClick={this.decrement.bind(this)}
                          >
                            <span className='branding-btn-font-color'>&#8722;</span>
                          </div>
                          <div className={`custom-increment-decrement__quantity ${branding_btn}`}>
                            <p>{this.state.quantity}</p>
                          </div>
                          <div
                            className={`custom-increment-decrement__increment card-subtitle-color ${branding_btn}`}
                            onClick={this.increment.bind(this)}
                          >
                            <span className='branding-btn-font-color'>&#43;</span>
                          </div>
                        </div>
                        {!this.props.isReward ?
                          <div
                            className={`item-modal-add-item ${branding_btn}`}
                            onClick={this.addOptionsAndGoBack.bind(this)}
                          >
                            <h2 className="branding-btn-font-color">
                              Add to Cart -&nbsp;
                              {originalPrice === discountedPrice ? (
                                originalPriceLabel
                              ) : (
                                <>
                                  <span className="branding-btn-font-color ml-4">
                                    {discountedPriceLabel}
                                  </span>
                                  &nbsp;
                                  <span className="text-decoration-line-through card-subtitle-color ml-1 form-control-sm font-weight-lighter">
                                    {originalPriceLabel}
                                  </span>
                                </>
                              )}
                            </h2>
                          </div> :
                          <div
                            className={`item-modal-add-item ${branding_btn}`}
                            onClick={this.addOptionsAndGoBack.bind(this)}
                          >
                            <h2 className="">
                              Add to Cart
                            </h2>
                          </div>

                        }
                      </div>
                    )}
                  </div>
                </div>
              </ModalFooter>
            </StyledModal>
          </React.Fragment>
        );
      }
    } else {
      return null;
    }
  }
}

const StyledModal = styled(Modal)`
  //z-index: 1050;
  //@media(max-width: 767px){
  //  margin-top: 30px;
  //}
  //.rodal-dialog{
  //  width: 575px !important;
  //  height: 80% !important;
  //  animation-duration: 300ms;
  //  padding: 0 !important;
  //}
  //.rodal-close{
  //  display: none !important;
  //}
  .close {
    border: unset;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export default withBackButtonHandled(ItemModal, (props) => {
  if (props.history.length > 2) props.history.goBack();
  else props.history.replace(`${CONSTANTS.BASE_URL}${props._location.slug}`);
});
